import Card from './Card';

interface AlreadyRespondedProps {
  status: string;
}

const COPY: Record<string, { title: string; body: string; tone: string }> = {
  ACCEPTED: {
    title: 'Quote already accepted',
    body: 'Thanks — this quote has already been accepted. The trades team will be in touch about the next steps.',
    tone: 'text-emerald-700 bg-emerald-50 border-emerald-200',
  },
  REJECTED: {
    title: 'Quote already declined',
    body: 'This quote was previously declined. If this was a mistake, please contact the sender directly.',
    tone: 'text-slate-700 bg-slate-50 border-slate-200',
  },
  CHANGES_REQUESTED: {
    title: 'Changes already requested',
    body: 'You have already asked for changes on this quote. The sender will review your feedback and follow up shortly.',
    tone: 'text-amber-800 bg-amber-50 border-amber-200',
  },
};

const AlreadyResponded = ({ status }: AlreadyRespondedProps) => {
  const copy = COPY[status] ?? {
    title: 'Quote no longer pending',
    body: `This quote has a status of "${status}" and is not awaiting a response.`,
    tone: 'text-slate-700 bg-slate-50 border-slate-200',
  };

  return (
    <Card className={['border-l-4', copy.tone].join(' ')}>
      <h2 className="text-lg font-semibold">{copy.title}</h2>
      <p className="mt-1 text-sm">{copy.body}</p>
    </Card>
  );
};

export default AlreadyResponded;
